import React, { Component } from 'react'
import { func, object } from 'prop-types'
import { Redirect, Route, withRouter } from 'react-router'
import { stores, initialization } from '../../stores'
import { PagesPaths } from '../../constants/Pages'

/**
 * Router helper that automatically redirect the user to the signin page
 * if not connected.
 * Optional parameter `redirect` can be given to redirect to another page (like signup)
 */
class RouteWhenAuthorizedComponent extends Component {
  // At application startup
  // wait for the initialization to be complete
  // then check if we need to redirect the user to the page he wanted to see
  async componentDidMount () {
    const { history } = this.props
    await initialization
    if (!stores.authentication.isAuthententicated()) { return }
    if (stores.location.redirection) {
      history.replace(stores.location.go())
    }
  }

  render () {
    const { component: Component, ...rest } = this.props
    return (
      <Route {...rest} render={renderProps => {
        if (stores.authentication.isAuthententicated()) {
          return <Component {...renderProps} />
        } else {
          stores.location.setRedirection(renderProps.location)
          return <Redirect to={{ pathname: rest.redirect || PagesPaths.SIGNIN.path }} />
        }
      }} />
    )
  }
}

RouteWhenAuthorizedComponent.propTypes = {
  component: func,
  history: object
}

export const RouteWhenAuthorized = withRouter(RouteWhenAuthorizedComponent)



// WEBPACK FOOTER //
// ./src/components/router/RouteWhenAuthorized.js